import {FidelityData} from "../../../features/fidelity/fidelity.types";

export const fidelityData: FidelityData = {
  name: "Ellen Ripley",
  firstName: "Ellen",
  cardCode: "123456789",
  pointsCollections: [
    {
      id: "1",
      name: "Raccolta punti 2025",
      points: 123
    }
  ]
}
